import { Component, OnInit, Input } from '@angular/core'

@Component({
    selector: 'app-profile-info-qanda',
    templateUrl: './profile-info-qanda.component.html',
    styleUrls: ['./profile-info-qanda.component.scss'],
    standalone: false,
})
export class ProfileInfoQandaComponent implements OnInit {
    @Input() qandaInfo: any[] = []

    public sectionList: any = []
    public qanda: any = []

    constructor() {}

    ngOnInit() {
        this.buildSectionList(this.qandaInfo)
    }

    ngOnChanges() {
        this.buildSectionList(this.qandaInfo)
    }

    removeNonPublicAnswers(qanda) {
        return qanda.filter((item) => item.public !== false)
    }

    buildSectionList(qanda: any) {
        while (this.sectionList.length > 0) {
            this.sectionList.pop()
        }
        var cur_section = 0
        if (typeof qanda !== 'undefined' && qanda.length > 0) {
            this.qanda = qanda.sort(function (a, b) {
                if (a.section < b.section) {
                    return -1
                }
                if (a.section > b.section) {
                    return 1
                }
                return 0
            })

            this.qanda = this.removeNonPublicAnswers(this.qanda)

            for (var x = 0; x < this.qanda.length; x++) {
                if (this.qanda[x].section !== cur_section) {
                    this.sectionList.push({
                        text: this.qanda[x].section_text,
                        id: this.qanda[x].section,
                    })
                    cur_section = this.qanda[x].section
                }
            }
        }
    }
}
